// extracted by mini-css-extract-plugin
module.exports = {"emptyText":"Configuration-module__emptyText___1K7Qx","table":"Configuration-module__table___GlIzJ","label":"Configuration-module__label___12Rqs"};